/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetUserWidgetsMetadataParams,
  UserWidgetDto,
  UserWidgetRequest,
  UserWidgetWithContentDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get user assigned widget with content</br></br>Authorities: **Any authenticated role**
 */
export const getUserWidgetContent = (
  userId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserWidgetWithContentDto>(
    { url: `/api/${userId}/user-widgets/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetUserWidgetContentQueryKey = (userId: string, id: number) => {
  return [`/api/${userId}/user-widgets/${id}`] as const;
};

export const getGetUserWidgetContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserWidgetContent>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserWidgetContentQueryKey(userId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserWidgetContent>>
  > = ({ signal }) => getUserWidgetContent(userId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserWidgetContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserWidgetContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserWidgetContent>>
>;
export type GetUserWidgetContentQueryError = ErrorType<unknown>;

export function useGetUserWidgetContent<
  TData = Awaited<ReturnType<typeof getUserWidgetContent>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetContent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserWidgetContent>>,
          TError,
          Awaited<ReturnType<typeof getUserWidgetContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserWidgetContent<
  TData = Awaited<ReturnType<typeof getUserWidgetContent>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetContent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserWidgetContent>>,
          TError,
          Awaited<ReturnType<typeof getUserWidgetContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserWidgetContent<
  TData = Awaited<ReturnType<typeof getUserWidgetContent>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserWidgetContent<
  TData = Awaited<ReturnType<typeof getUserWidgetContent>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserWidgetContentQueryOptions(userId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update user assigned widget</br></br>Authorities: **Any authenticated role**
 */
export const updateUserWidget = (
  userId: string,
  id: number,
  userWidgetRequest: BodyType<UserWidgetRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserWidgetDto>(
    {
      url: `/api/${userId}/user-widgets/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: userWidgetRequest,
      signal,
    },
    options
  );
};

export const getUpdateUserWidgetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserWidget>>,
    TError,
    { userId: string; id: number; data: BodyType<UserWidgetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserWidget>>,
  TError,
  { userId: string; id: number; data: BodyType<UserWidgetRequest> },
  TContext
> => {
  const mutationKey = ['updateUserWidget'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserWidget>>,
    { userId: string; id: number; data: BodyType<UserWidgetRequest> }
  > = (props) => {
    const { userId, id, data } = props ?? {};

    return updateUserWidget(userId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserWidgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserWidget>>
>;
export type UpdateUserWidgetMutationBody = BodyType<UserWidgetRequest>;
export type UpdateUserWidgetMutationError = ErrorType<unknown>;

export const useUpdateUserWidget = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserWidget>>,
      TError,
      { userId: string; id: number; data: BodyType<UserWidgetRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserWidget>>,
  TError,
  { userId: string; id: number; data: BodyType<UserWidgetRequest> },
  TContext
> => {
  return useMutation(getUpdateUserWidgetMutationOptions(options), queryClient);
};
/**
 * Get user assigned widget metadata for current user, by default filtered by viewed=false</br></br>Authorities: **Any authenticated role**
 */
export const getUserWidgetsMetadata = (
  userId: string,
  params?: GetUserWidgetsMetadataParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserWidgetDto[]>(
    { url: `/api/${userId}/user-widgets`, method: 'GET', params, signal },
    options
  );
};

export const getGetUserWidgetsMetadataQueryKey = (
  userId: string,
  params?: GetUserWidgetsMetadataParams
) => {
  return [`/api/${userId}/user-widgets`, ...(params ? [params] : [])] as const;
};

export const getGetUserWidgetsMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUserWidgetsMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserWidgetsMetadataQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserWidgetsMetadata>>
  > = ({ signal }) =>
    getUserWidgetsMetadata(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserWidgetsMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserWidgetsMetadata>>
>;
export type GetUserWidgetsMetadataQueryError = ErrorType<unknown>;

export function useGetUserWidgetsMetadata<
  TData = Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: undefined | GetUserWidgetsMetadataParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserWidgetsMetadata>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserWidgetsMetadata<
  TData = Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUserWidgetsMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserWidgetsMetadata>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserWidgetsMetadata<
  TData = Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUserWidgetsMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserWidgetsMetadata<
  TData = Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUserWidgetsMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserWidgetsMetadata>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserWidgetsMetadataQueryOptions(
    userId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
